import React, { useMemo } from 'react';
import { Select, TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';

import { CANADA_STATES, COUNTRIES, USA_STATES } from '../constants';
import cn from '../ApplicationForm.module.scss';
import InputLabel from '../InputLabel/InputLabel';

function getStates(country) {
  return country === COUNTRIES.canada.value ? CANADA_STATES : USA_STATES;
}

export function AddressForm({ values, onChange }) {
  const { country, state, address, city, zipcode } = values;

  const states = useMemo(() => {
    return getStates(country.value);
  }, [country.value]);

  const handleChange = (event) => {
    const { name, value: newValue } = event.target;

    const addressKeyValuePairs = Object.entries(values).reduce((obj, [k, v]) => {
      return {
        ...obj,
        [k]: v.value,
      };
    }, {});

    if (name === 'country') {
      const [initialState] = getStates(newValue);
      return onChange({
        ...addressKeyValuePairs,
        [name]: newValue,
        state: initialState,
      });
    }

    return onChange({
      ...addressKeyValuePairs,
      [name]: newValue,
    });
  };

  return (
    <div>
      <div className={cn.row}>
        <div className={cn.field}>
          <InputLabel
            text={country.label || 'Country:'}
            required={country.required}
            error={country.error}
          />
          <Select
            variant="outlined"
            value={country.value}
            name="country"
            onChange={handleChange}
            className={cn.select}
            error={!!country.error}
          >
            {Object.values(COUNTRIES).map((country) => (
              <MenuItem key={country.value} value={country.value}>
                {country.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className={cn.field}>
          <InputLabel
            text={state.label || 'State/Province:'}
            required={state.required}
            error={state.error}
          />
          <Select
            variant="outlined"
            name="state"
            onChange={handleChange}
            className={cn.select}
            value={state.value}
            error={!!state.error}
          >
            {states.map((state) => (
              <MenuItem key={state} value={state}>
                {state}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <div className={cn.row}>
        <div className={cn.field}>
          <InputLabel
            text={address.label || 'Current Legal Address:'}
            required={address.required}
            error={address.error}
          />
          <TextField
            value={address.value}
            variant="outlined"
            name="address"
            fullWidth
            onChange={handleChange}
            error={!!address.error}
          />
        </div>
        <div className={cn.field}>
          <InputLabel
            text={city.label || 'City:'}
            required={city.required}
            error={city.error}
          />
          <TextField
            value={city.value}
            variant="outlined"
            name="city"
            fullWidth
            onChange={handleChange}
            error={!!city.error}
          />
        </div>
        <div className={cn.field}>
          <InputLabel
            text={zipcode.label || 'Zip/Postal code:'}
            required={zipcode.required}
            error={zipcode.error}
          />
          <TextField
            value={zipcode.value}
            variant="outlined"
            name="zipcode"
            fullWidth
            onChange={handleChange}
            inputProps={{
              maxlength: 12,
            }}
            error={!!zipcode.error}
          />
        </div>
      </div>
    </div>
  );
}
